import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/adminWork-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/AdminWorkForm';
import { IAdminWork } from 'src/types/adminWork';
import { IProvider } from '../../../../../../types/provider';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { QueryParams } from '../../../../../../types/grid';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';
import { changeToZeroZoneDate } from '../../../../../../helpers/timeHelpers';

export interface StateProps {
    adminWork: IAdminWork | null;
    inProgress: boolean;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getProviders: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const AdminWorkEditScreen: FC<Props> = (props: Props) => {
    const {
        adminWork,
        inProgress,
        match: {
            params: { id },
        },
        getData,
    } = props;
    useEffect(() => {
        props.getProviders({
            page: 1,
            itemsPerPage: 1200,
        });
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (!adminWork || adminWork.id !== id) {
            getData(id);
        }

        // eslint-disable-next-line
    }, [getData, id]);

    if (!adminWork || inProgress) {
        return <Loader />;
    }
    const { providers } = props;
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'ADMIN WORKS', path: routes.ADMIN_WORKS_LIST },
                    { name: `EDIT ${adminWork?.id ? adminWork?.id : ''}`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                <Form
                    providers={providers.list}
                    initialValues={{
                        ...adminWork,
                        startTime: adminWork.startTime ? changeToZeroZoneDate(adminWork['startTime']) : '',
                        endTime: adminWork.endTime ? changeToZeroZoneDate(adminWork['endTime']) : '',
                        providerDropDown: { value: adminWork.provider?.id, label: `${adminWork.provider?.fullName}` },
                    }}
                />
            </div>
        </RoleLayout>
    );
};
export default AdminWorkEditScreen;
